import React from "react";

const SvgBikelocker = ({ title, ...props }) => (
  <svg
    id="bike_locker_svg__Layer_2_1_"
    x={0}
    y={0}
    viewBox="0 0 390 390"
    xmlSpace="preserve"
    {...props}
  >
    {title ? <title>{title}</title> : null}
    <style>{".bike_locker_svg__st0{fill:#010101}"}</style>
    <path
      className="bike_locker_svg__st0"
      d="M309.3 47.1c-1.2-1.2-19.8-19.3-19.8-19.3H182.1C172.6 11.1 154.9 0 134.5 0c-30.3 0-54.8 24.6-54.8 54.8 0 30.3 24.5 54.8 54.8 54.8 20.9 0 39.1-11.6 48.3-28.9h19.6l16.9-17.3 13 13.6 13.2-13.6L258.4 77l13.2-13.6L285 77.1l24.3-24.3c1.4-1.2 1.4-4.6 0-5.7zM109 70.5c-8.7 0-15.7-7-15.7-15.6 0-8.7 7-15.6 15.7-15.6s15.6 7 15.6 15.6-6.9 15.6-15.6 15.6zM164.2 205.3h-22.8c-3.2 0-5.7-2.6-5.7-5.7s2.6-5.7 5.7-5.7h22.8c3.2 0 5.7 2.6 5.7 5.7s-2.6 5.7-5.7 5.7z"
    />
    <path
      className="bike_locker_svg__st0"
      d="M373.7 390H16.3V127.7h357.3V390h.1zM44.5 361.8h301V156h-301v205.8z"
    />
    <path
      className="bike_locker_svg__st0"
      d="M275.9 236.3c-6.7 0-13.2 1.3-19.1 3.8-1.7-4.3-3.1-8-4-10.6v-.1L236.1 185c-.8-2.2-3-3.7-5.3-3.7h-22c-3.2 0-5.7 2.6-5.7 5.7 0 3.2 2.6 5.7 5.7 5.7h18l7 18.8h-76.3c-2 0-3.8 1-4.8 2.7l-17.5 27.4c-6.6-3.3-14.1-5.1-22.1-5.1-27.5 0-50.1 22.5-50.1 50.3 0 27.8 22.6 50.3 50.3 50.3 25.8 0 47.2-19.5 50-44.6h20.4c1.6 0 3.2-.7 4.2-1.8l54.6-55.7c.7 2 2.2 5.9 4.2 10.9-12.9 9.1-21.2 24.1-21.2 41 0 27.8 22.6 50.3 50.3 50.3 27.8 0 50.3-22.6 50.3-50.3.1-28-22.5-50.6-50.2-50.6zm-135 77.9c-7.4 7.4-17.2 11.4-27.6 11.4s-20.2-4.1-27.6-11.4-11.4-17.2-11.4-27.6c0-10.4 4.1-20.2 11.4-27.6s17.2-11.4 27.6-11.4 20.2 4.1 27.6 11.4c6 6 9.8 13.6 11 21.8h-38.5c-3.2 0-5.7 2.6-5.7 5.7 0 3.2 2.6 5.7 5.7 5.7h38.5c-1.2 8.5-5 16-11 22zm22.5-33.2c-1.5-13.5-8.4-25.3-18.4-33.4l11.3-17.8 19.3 51.1h-12.2zm22.5-4.6l-20.1-53.5h72.3l.1.1-52.3 53.4zm117.5 37.8c-7.4 7.4-17.2 11.4-27.6 11.4-10.4 0-20.2-4.1-27.6-11.4-7.4-7.4-11.4-17.2-11.4-27.6 0-10.4 4.1-20.2 11.4-27.6.9-.9 1.9-1.8 3-2.7v.1c7.6 16.9 14.4 28.5 20.6 34.3 1.1 1 2.5 1.5 3.9 1.5 1.5 0 3.1-.6 4.2-1.7 2.1-2.2 2-5.9-.2-8.1-6.1-5.7-13.1-19.4-18.6-32 4.6-1.8 9.6-2.9 14.7-2.9 10.4 0 20.2 4.1 27.6 11.4 7.4 7.4 11.4 17.2 11.4 27.6.1 10.6-4 20.4-11.4 27.7z"
    />
  </svg>
);

export default SvgBikelocker;
